import {CONNECTED_OFFERS, SMARTLINKS} from "../../../utils/constants";
import {URL_OFFERS, URL_OFFERS_MANAGER} from "../../../properties";
import {isAdminAsPartner} from "../../../utils/authUtils";
import {getBasePagePartnerId} from "./basePagePartnerMode";

const DEFAULT_TITLE = "Affimob - Wapclick партнёрская программа, wap подписки.";
const SMALL_DEVICE_WIDTH = 1024;

export const handleBasePageDocumentClick = (e) => {
    let href;

    if (e.target.tagName === 'A') {
        href = e.target.getAttribute('href');
    } else if (e.target.parentElement && e.target.parentElement.tagName === 'A') {
        href = e.target.parentElement.getAttribute('href');
    }

    if (href === '#') {
        e.preventDefault();
    }
};

export const applyBasePageResizeEffects = () => {
    const bodyClassList = document.body.classList;

    if (window.innerWidth < SMALL_DEVICE_WIDTH) {
        bodyClassList.add('small-device');
    } else {
        bodyClassList.remove('small-device');
    }
};

export const applyBasePageLayoutEffects = () => {
    const rootElement = document.getElementById("root");

    if (rootElement) {
        rootElement.classList.add("main-page-content");
    }

    const bodyClassList = document.body.classList;
    bodyClassList.remove('no-padding');
    bodyClassList.remove("morda");
    bodyClassList.remove('rules-body');
};

export const applyBasePageRouteEffects = () => {
    applyBasePageLayoutEffects();
    applyBasePageOffersEffects();
    applyBasePageResizeEffects();
};

export const applyBasePageOffersEffects = () => {
    const bodyClassList = document.body.classList;
    const isOffersPage = window.location.pathname === URL_OFFERS || window.location.pathname === URL_OFFERS_MANAGER;

    if (!isOffersPage) {
        bodyClassList.remove('bodyOffers');
        return;
    }

    if (window.location.search.includes(CONNECTED_OFFERS) || window.location.search.includes(SMARTLINKS)) {
        bodyClassList.remove('bodyOffers');
    } else {
        bodyClassList.add('bodyOffers');
    }
};

export const setBasePageTitle = (loadUserData) => {
    if (isAdminAsPartner()) {
        const partnerEmail = localStorage.getItem('user' + getBasePagePartnerId());

        if (partnerEmail) {
            setPartnerEmailTitle(partnerEmail);
        } else {
            loadUserData(cachePartnerEmailAndSetTitle);
        }

        return;
    }

    document.title = DEFAULT_TITLE;
};

export const cachePartnerEmailAndSetTitle = (partner) => {
    if (!partner) {
        return;
    }

    localStorage.setItem('user' + partner.id, partner.email);
    setPartnerEmailTitle(partner.email);
};

export const setPartnerEmailTitle = (email) => {
    if (!email) {
        return;
    }

    document.title = "Affimob | " + email;
};
